import { CompanyContactType } from '@api';
import { PersonAnchor } from '../PersonAnchor';

type ContactPersonAnchorPropsType = {
  contactPerson: CompanyContactType;
};
export const ContactPersonAnchor: React.FC<ContactPersonAnchorPropsType> = ({
  contactPerson,
}) => {
  return (
    <PersonAnchor
      person={{
        type: 'PERSON',
        id: contactPerson.personId,
        name: `${contactPerson.personName} - ${contactPerson.companyName}`,
      }}
    />
  );
};
